import { signalStore } from '@ngrx/signals';
import { UserData, UserRef, UserDef } from '../../schema/schema.interface';
import { UserActions } from './user.action';
import { UserState } from './user.state';
import { OffSubscriptionWithCatch, AbstractQueryParams, withActions, withSelectors } from '@res/ngg-core';

export type UserStoreModel = UserData & { ref: UserRef };
export interface UserStateModel {
  users: UserStoreModel[];
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean | string;
  filter?: { query: AbstractQueryParams<UserDef>[] };
}

export const UserStore = signalStore(
  // Selectors
  { protectedState: false, providedIn: 'root' },
  withSelectors({
    users: UserState.users,
    userState: UserState.userState,
  }),
  // Actions
  withActions({
    initUsers: UserActions.InitUsers,
    getAllUsers: UserActions.GetAllUser,
    updateUser: UserActions.UpdateUser,
    deleteUser: UserActions.DeleteUser,
    queryUser: UserActions.QueryUser,
  }),
);
